export const SHIPPING_LABELS = 'checkout.shipping';
export const BILLING_LABELS = 'checkout.billing';
export const ACCOUNT_COMMON_LABELS = 'account.common';
export const ADDRESS_LABELS = 'global.addEditAddress';

export const lblGiftServicesAddMessage = 'lbl_giftServices_addMessage';
export const lblGiftServicesCharLimit = 'lbl_giftServices_charLimit';
export const lblGiftServiceOptionNone = 'lbl_gift_service_option_none';
export const lblAddGiftServices = 'lbl_add_gift_services';
export const lblGiftServicesHelp = 'lbl_giftServices_help';
export const lblGiftServicesAdd = 'lbl_giftServices_add';
export const lblGiftServicesSelect = 'lbl_giftServices_select';
export const lblGiftServicesHeader = 'lbl_giftServices_header';
export const lblGiftServiceSelectABrand = 'lbl_gift_service_select_a_brand';
export const lblGiftServiceOptional = 'lbl_gift_service_optional';
export const lblGiftServiceSave = 'lbl_gift_service_save';
export const lblGiftServiceNoteDelux = 'lbl_gift_service_note_delux';
export const lblGiftServiceNoteStandard = 'lbl_gift_service_note_standard';
export const lblShippingDefault = 'lbl_shipping_default';
export const lblShippingAddNewAddress = 'lbl_shipping_addNewAddress';
export const lblShippingEdit = 'lbl_shipping_edit';
export const lblShippingSectionHeader = 'lbl_shipping_sectionHeader';
export const lblShippingSaveToAccount = 'lbl_shipping_saveToAccount';
export const lblShippingDefaultShipping = 'lbl_shipping_defaultShipping';
export const lblShippingSave = 'lbl_shipping_save';
export const lblShippingAddHeading = 'lbl_shipping_addHeading';
export const lblShippingEditHeading = 'lbl_shipping_editHeading';
export const lblShippingReviewText = 'lbl_shipping_reviewText';
export const lblShippingBillingText = 'lbl_shipping_billingText';
export const lblShippingHeader = 'lbl_shipping_header';
export const lblShippingShipmentHeader = 'lbl_shipping_shipmentHeader';
export const lblShippingBackLinkText = 'lbl_shipping_backLinkText';

export const lblSfsShippingAddressError = 'lbl_sfs_shipping_address_error';
export const lblSfsOrderError = 'lbl_sfs_order_error';
export const lblSfsErrorRushShipping = 'lbl_sfs_error_rush_shipping';
export const lblSfsErrorGiftService = 'lbl_sfs_error_gift_service';
export const lblSfsErrorShippingAddress = 'lbl_sfs_error_shipping_address';
export const lblSfsErrorAddressRush = 'lbl_sfs_error_address_rush';
export const lblSfsErrorGiftAddress = 'lbl_sfs_error_gift_address';
export const lblSfsErrorGiftRush = 'lbl_sfs_error_gift_rush';

// global addEditAddress
export const lblAddEditAddressSaveAndContinue = 'lbl_addEditAddress_saveAndContinue';
export const lblAddEditAddressRegAddNewAddress = 'lbl_addEditAddress_regAddNewAddress';
export const lblAddEditAddressRegEditAddress = 'lbl_addEditAddress_regEditAddress';
export const lblAddEditAddressAddNewBtn = 'lbl_addEditAddress_addNew_btn';
export const lblAddEditAddressAddAddress = 'lbl_addEditAddress_addAddress';
export const lblAddEditAddressSelectFromAddressBook = 'lbl_addEditAddress_selectFromAddressBook';

// account common
export const lblCommonTapClose = 'lbl_common_tapClose';
export const lblCommonMakeDefault = 'lbl_common_makeDefault';
export const lblCommonAddress = 'lbl_common_address';
export const lblGsWarningTxt = 'lbl_gs_warning_txt';
export const lblGsNoteTxt = 'lbl_gs_note_txt';

// checkout billing
export const lblBillingDefault = 'lbl_billing_default';

const ShippingPageLabels = {
  checkout: {
    shipping: {
      [lblGiftServicesAddMessage]: 'Add your message',
      [lblGiftServicesCharLimit]: '100 character limit',
      [lblGiftServiceOptionNone]: 'None',
      [lblAddGiftServices]: 'Add Gift Services',
      [lblGiftServicesHelp]: 'Gift Services Help',
      [lblGiftServicesAdd]: 'Add a personalized message, gift receipt and/or gift boxes.',
      [lblGiftServicesSelect]: 'Select from the options below.',
      [lblGiftServicesHeader]: 'Gift Services',
      [lblGiftServiceSelectABrand]:
        'Select a brand and a gift service. Add a personalized message, gift receipt, and/or gift box.',
      [lblGiftServiceOptional]: 'Optional',
      [lblGiftServiceSave]: 'Save',
      [lblGiftServiceNoteDelux]:
        '<b>*Note:</b> If choosing this service, please note that all merchandise in your cart will be shipped directly to gift recipient. We are unable to split shipments at this time.',
      [lblGiftServiceNoteStandard]:
        "<b>*Note:<b/> Gift Boxes will not be sent for each item in your order. you'll receive an estimated number of boxes needed to gift all the items from your purchase to one recipient.",
      [lblShippingDefault]: 'DEFAULT',
      [lblShippingAddNewAddress]: ' + Add A New Address',
      [lblShippingEdit]: ' Edit',
      [lblShippingSectionHeader]: 'Shipping Details',
      [lblShippingSaveToAccount]: 'Save to my address book',
      [lblShippingDefaultShipping]: 'Set as default shipping address',
      [lblShippingSave]: 'Save',
      [lblShippingAddHeading]: 'ADD NEW ADDRESS',
      [lblShippingEditHeading]: 'EDIT ADDRESS',
      [lblShippingReviewText]: 'NEXT: REVIEW',
      [lblShippingBillingText]: 'NEXT: BILLING',
      [lblShippingHeader]: 'SHIPPING',
      [lblShippingShipmentHeader]: 'Shipping Method',
      [lblShippingBackLinkText]: 'Return to Pickup',

      [lblSfsShippingAddressError]: 'Important message for your shipping address.',
      [lblSfsOrderError]: 'Important message for your order.',
      [lblSfsErrorRushShipping]:
        'X item(s) in your cart are not eligible for Express or RUSH shipping.',
      [lblSfsErrorGiftService]: 'X item(s) in your cart not eligible for gift services.',
      [lblSfsErrorShippingAddress]:
        'X item(s) in your cart not eligible.  APO/FPO address entered is not eligible.',
      [lblSfsErrorAddressRush]:
        'X Item(s) in your cart are not eligible for shipment to APO/FPO address and Expedited/RUSH Shipping.',
      [lblSfsErrorGiftAddress]:
        'X item(s) in your cart not eligible for gift services and the APO/FPO address entered is not eligible.',
      [lblSfsErrorGiftRush]:
        'X Item(s) in your cart are not eligible for Rush/Expedited Shipping and Gift Services',
      [lblGsWarningTxt]: 'Gift services are only available for Ship to Home items!',
      [lblGsNoteTxt]: 'Note: ',
    },
    billing: {
      [lblBillingDefault]: 'Default',
    },
  },
  global: {
    addEditAddress: {
      [lblAddEditAddressSaveAndContinue]: 'SAVE & CONTINUE',
      [lblAddEditAddressRegAddNewAddress]: 'Add New Address',
      [lblAddEditAddressRegEditAddress]: 'Edit Address',
      [lblAddEditAddressAddNewBtn]: 'Add New',
      [lblAddEditAddressAddAddress]: 'Add Address',
      [lblAddEditAddressSelectFromAddressBook]: 'Select From Address Book',
    },
  },
  account: {
    common: {
      [lblCommonTapClose]: 'Tap to close it',
      [lblCommonMakeDefault]: 'Make Default',
      [lblCommonAddress]: 'Address',
    },
  },
};
export default ShippingPageLabels;
